import { Component } from 'react'
import * as styles from 'components/features/pfm/Overflower/Overflower.styl'
import { getNamedChildrenRenderer, getChildWithType } from 'tangle-shared'

// for detailed explanation see https://www.kizu.ru/flexible-overflow/
class Overflower extends Component {
  static Short = getNamedChildrenRenderer('Short')
  static Long = getNamedChildrenRenderer('Long')
  render () {
    const shortChild = getChildWithType(this.props.children, Overflower.Short)
    const longChild = getChildWithType(this.props.children, Overflower.Long)

    return (
      <div className={ styles.overflower }>
        <div className={ styles.overflowerShort }>
          { shortChild }
        </div>
        <div className={ styles.overflowerLong }>
          { longChild }
        </div>
      </div>
    )
  }
}

export default Overflower


